import Vue  from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state     : {
		user : null
	},
	mutations : {
		setUser (state, user) {
			// mutate state
			state.user = user
		}
	},
	actions   : {},
	modules   : {}
})
